<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="出货单自动签收" name="out_warehose_auto_sign_day">
          <a-radio-group v-model:value="form.out_warehose_auto_sign_enable">
            <a-radio :value="1">开启</a-radio>
            <a-radio :value="0">关闭</a-radio>
          </a-radio-group>
          <div class="s_flex_ali" v-if='form.out_warehose_auto_sign_enable == 1'>
            <p class="s_c333">商品出货后</p>
            <a-input-number v-model:value="form.out_warehose_auto_sign_day" style="width:150px;margin: 0 8px;" :min='0' :max='99' :precision='0' placeholder='请输入天数' />
            <p>天，收货单自动签收</p>
          </div>
        </a-form-item>
       <a-form-item label="未出库商品允许销售" name="un_out_is_sold">
          <a-radio-group v-model:value="form.un_out_is_sold">
            <a-radio :value="1">允许</a-radio>
            <a-radio :value="0">不允许</a-radio>
          </a-radio-group>
              <a-tooltip placement='right'>
            <template #title>
              <p>1、默认不允许：未出库商品不允许消费者正常扫码，不记录销售状态</p>
              <p>2、允许：未出库商品允许消费者正常扫码，记录销售状态，但消费者扫码后不能进行出入库扫码</p>
            </template>
            <InfoCircleOutlined class="s_c376" />
          </a-tooltip>
        </a-form-item>
        <a-form-item label="经销商禁用后" name="dealer_scan_tip">
          <a-radio-group v-model:value="form.dealer_enable_after">
            <a-radio :value="1">允许查询和参与活动</a-radio>
            <a-radio :value="2">不允许查询和参与活动</a-radio>
            <a-radio :value="3">只允许查询，不允许参与活动</a-radio>
          </a-radio-group>
          <a-tooltip placement='right'>
            <template #title>针对经销商被禁用后，其手里未发出或销售的商品</template>
            <InfoCircleOutlined class="s_c376" />
          </a-tooltip>
          <div class="s_flex_ali" v-if='form.dealer_enable_after == 2'>
            <p class="s_c333">扫码提示语</p>
            <a-input v-model:value="form.dealer_scan_tip" style="width:370px;margin: 0 8px;" :maxlength='30' placeholder='请输入提示语' />
            <p class="s_c333">限30字内</p>
          </div>
        </a-form-item>
        <a-form-item label="门店禁用后" name="store_scan_tip">
          <a-radio-group v-model:value="form.store_enable_after">
            <a-radio :value="1">允许查询和参与活动</a-radio>
            <a-radio :value="2">不允许查询和参与活动</a-radio>
            <a-radio :value="3">只允许查询，不允许参与活动</a-radio>
          </a-radio-group>
          <a-tooltip placement='right'>
            <template #title>针对门店被禁用后，其手里未发出或销售的商品</template>
            <InfoCircleOutlined class="s_c376" />
          </a-tooltip>
          <div class="s_flex_ali" v-if='form.store_enable_after == 2'>
            <p class="s_c333">扫码提示语</p>
            <a-input v-model:value="form.store_scan_tip" style="width:370px;margin: 0 8px;" :maxlength='30' placeholder='请输入提示语' />
            <p class="s_c333">限30字内</p>
          </div>
        </a-form-item>
        <a-form-item label="商品窜货禁用后" name="product_ch_scan_tip">
          <a-radio-group v-model:value="form.product_ch_enable_after">
            <a-radio :value="1">允许查询和参与活动</a-radio>
            <a-radio :value="2">不允许查询和参与活动</a-radio>
            <a-radio :value="3">只允许查询，不允许参与活动</a-radio>
          </a-radio-group>
          <div class="s_flex_ali" v-if='form.product_ch_enable_after == 2'>
            <p class="s_c333">扫码提示语</p>
            <a-input v-model:value="form.product_ch_scan_tip" style="width:370px;margin: 0 8px;" :maxlength='30' placeholder='请输入提示语' />
            <p class="s_c333">限30字内</p>
          </div>
        </a-form-item>
        <a-form-item label="消费者扫码后" name="cosumer_scan_code_after">
          <a-radio-group v-model:value="form.cosumer_scan_code_after">
            <a-radio :value="1">扣除渠道1个商品</a-radio>
            <a-radio :value="2">扣除渠道1箱商品</a-radio>
          </a-radio-group>
        </a-form-item>

     
    
        <a-form-item label="门店未签收的商品" name="store_no_sign_product_tip">
          <a-radio-group v-model:value="form.store_no_sign_product">
            <a-radio :value="1">允许查询和参与活动</a-radio>
            <a-radio :value="2">不允许查询和参与活动</a-radio>
            <a-radio :value="3">只允许查询，不允许参与活动</a-radio>
          </a-radio-group>
          <div class="s_flex_ali" v-if='form.store_no_sign_product == 2'>
            <p class="s_c333">扫码提示语</p>
            <a-input v-model:value="form.store_no_sign_product_tip" style="width:370px;margin: 0 8px;" :maxlength='30' placeholder='请输入提示语' />
            <p class="s_c333">限30字内</p>
          </div>
        </a-form-item>
        
        <a-form-item label="发给经销商的出货单手动签收方式" name="out_warehose_passive_sign_enable">
          <a-radio-group v-model:value="form.out_warehose_passive_sign_enable">
            <a-radio :value="1">一键签收</a-radio>
            <a-radio :value="2">扫码签收</a-radio>
          </a-radio-group>
        </a-form-item>
               <a-form-item label="门店签收设置" name="out_warehose_passive_sign_enable_store">
          <a-radio-group v-model:value="form.out_warehose_passive_sign_enable_store">
            <a-radio :value="1">一键签收</a-radio>
            <a-radio :value="2">扫码签收</a-radio>
          </a-radio-group>
        </a-form-item>
        <!-- <a-form-item label="自动取消发货" name="auto_cancel_out_warehouse_hour">
          <div class="s_flex_ali">
            <p>发货中的出库单、调仓单、调拨单</p>
            <a-input-number v-model:value="form.auto_cancel_out_warehouse_hour" style="width:150px;margin: 0 8px;"  :min='1' :max='99' :precision='0' placeholder='请输入天数' />
            <p>小时没有进行二维码相关操作，系统自动取消发货</p>
          </div>
        </a-form-item> -->

        <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
          <a-button style="width:100px" type="primary" v-has:antiSystemConfigSubmit="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>
<script>
  import { InfoCircleOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { message } from 'ant-design-vue';
  import { iscode } from "@/utils/app";
  import { getAdminSys, setAdminSys } from "@/api/antiFleeing";
  // 初始化默认筛选项数值
  let defForm = {
    out_warehose_auto_sign_enable:1,
    out_warehose_auto_sign_day:7,
    dealer_enable_after:1,
    dealer_scan_tip:'经销商已被禁用，无法查看商品相关信息',
    store_enable_after:1,
    store_scan_tip:'门店已被禁用，无法查看商品相关信息',
    product_ch_enable_after:1,
    product_ch_scan_tip:'商品有窜货嫌疑，无法查看商品相关信息',
    cosumer_scan_code_after:1,
    dealer_stock_warning_num:100,
    store_stock_warning_num:100,
    dead_product_day:180,
    store_no_sign_product:1,
    store_no_sign_product_tip:'商品未出库到门店，无法查看商品相关信息',
    auto_cancel_out_warehouse_hour:3,
    receive_wx_push:0,
    un_out_is_sold:0
  }
  
  export default {
    components: {InfoCircleOutlined},
    setup() {
      let out_warehose_auto_sign_day = async () => {
        if (form.value.out_warehose_auto_sign_enable == 1 &&  !isNumber(form.value.out_warehose_auto_sign_day)) {
          return Promise.reject('请输入自动签收时间');
        } else {
          return Promise.resolve();
        }
      };
      let dealer_scan_tip = async () => {
        if (form.value.dealer_enable_after == 2 &&  !form.value.dealer_scan_tip) {
          return Promise.reject('请输入扫码提示语');
        } else {
          return Promise.resolve();
        }
      };
      let store_scan_tip = async () => {
        if (form.value.store_enable_after == 2 &&  !form.value.store_scan_tip) {
          return Promise.reject('请输入扫码提示语');
        } else {
          return Promise.resolve();
        }
      };
      let product_ch_scan_tip = async () => {
        if (form.value.product_ch_enable_after == 2 &&  !form.value.product_ch_scan_tip) {
          return Promise.reject('请输入扫码提示语');
        } else {
          return Promise.resolve();
        }
      };
      let store_no_sign_product_tip = async () => {
        if (form.value.store_no_sign_product == 2 &&  !form.value.store_no_sign_product_tip) {
          return Promise.reject('请输入扫码提示语');
        } else {
          return Promise.resolve();
        }
      };
      const form = ref({ ...defForm });
      const state = reactive({
        labelCol: { span: 3 },
        wrapperCol: { span: 16 },
        rules: {
          out_warehose_auto_sign_day: [
            { required: true, validator: out_warehose_auto_sign_day}
          ],
          dealer_scan_tip: [
            { required: true, validator: dealer_scan_tip}
          ],
          store_scan_tip: [
            { required: true, validator: store_scan_tip}
          ],
          product_ch_scan_tip: [
            { required: true, validator: product_ch_scan_tip}
          ],
          dealer_stock_warning_num: [
            { required: true, message: '请输入经销商库存预警商品数量',type: 'number'}
          ],
          store_stock_warning_num: [
            { required: true, message: '请输入门店库存预警商品数量',type: 'number'}
          ],
          dead_product_day: [
            { required: true, message: '请输入呆滞品天数',type: 'number'}
          ],
          store_no_sign_product_tip: [
            { required: true, validator: store_no_sign_product_tip}
          ],
          auto_cancel_out_warehouse_hour: [
            { required: true, message: '请输入自动取消发货时间',type: 'number'}
          ]
        }
      });
      const ruleForm = ref()
      const  isNumber = (obj) => {
        return !isNaN(parseFloat(obj)) && isFinite(obj);
      }
      const getMore = async () => {
        // const hide = message.loading('正在加载中...', 0)
        let res = await getAdminSys().then(res => res.data).catch(error => error);
        if (iscode(res)) {
          form.value = res.data
        } else {
          message.error(res.msg)
        }
        // setTimeout(hide);
      }
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          const hide = message.loading('正在加载中...', 0);
          let res = await setAdminSys({ ...form.value }).then(res => res.data).catch(error => error);
          if (iscode(res)) {
            message.success(res.msg);
            getMore();
          } else {
            message.error(res.msg);
          }
          setTimeout(hide);
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
        getMore();
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
      }
    }
  }
</script>